<div class="my-3 my-md-5">
    <div class="container-fluid px-4">
            <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" />
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Source"  [(ngModel)]="lead_source" multiple>
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Status"  [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                                <input class="mySearchInput"
                                #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="lead_status_Search">
                                <mat-option [value]="lstatus.id" *ngFor="let lstatus of leadallStatus">{{lstatus.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple #itemSelect="ngModel">
                                <input class="mySearchInput"
                                #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="bd_search">
                                <div class="btn-group col-sm-12">
                                    <button class="btn btn-primary width50" mat-button (click)="selectAll(itemSelect)">Select All</button>
                                    <button class="btn btn-danger width50" mat-button (click)="deselectAll(itemSelect)">Deselect All</button>
                                </div>
                                <mat-option value="{{bd.id}}" *ngFor="let bd of allbds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" >
                            <mat-select  placeholder="Circle"  [(ngModel)]="circle" (click)="setSearchValue('circle')" multiple>
                                <input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of alltreatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Catergory" [(ngModel)]="lead_category_filter" multiple>
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode" [(ngModel)]="payment_mode" multiple>
                                <mat-option value="Cash">Cash</mat-option>
                                <mat-option value="Cashless">Cashless</mat-option>
                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                <mat-option value="EMI">EMI</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter Lead Date date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter Follow-Up date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker1">
                                    <input matStartDate #followupdateRangeStart placeholder="Start date">
                                    <input matEndDate #followupdateRangeEnd placeholder="End date" (dateChange)="dateRangeChangefollowUp(followupdateRangeStart, followupdateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDateFollowUp()">clear</mat-icon>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <label class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input"  [(ngModel)]="c2crecording" />
                              <span class="custom-control-label">Display Nimbus C2C Recording Leads</span>
                            </label>
                          </div>
                        <div class="col-sm-3 mt-3">
                            <button type="button" [disabled]="loading" class="btn btn-primary ml-2 mb-4" (click)="loadleads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                            <button type="button" [disabled]="loading" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Reset Filters</button>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-8 p-3">
                    <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="loadleads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh Sheet</button>
                    <button type="button" *ngIf="myrole=='1' || myrole=='15'" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="exportRecordingLeadData()"><i class="fa fa-file-excel"></i> Export List </button>
                </div>
                <div class="col-sm-4">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Lead Id</th>
                            <th>Glamyo Patient Id</th>
                            <th>Lead Source</th>
                            <th>Status</th>
                            <th>Lead Location</th>
                            <th>Circle</th>
                            <th>Lead Owner</th>
                            <th>Employee Id</th>
                            <th>Treatment</th>
                            <th>Description</th>
                            <th>Lead Time</th>
                            <!-- <th>First Action Log</th> -->
                            <th>Followup Date</th>
                            <!-- <th>Kaleyra Call Recording</th>
                            <th>Kaleyra C2C Recording</th> -->
                            <th>Nimbus C2C Recording</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let lead of leads;let index = index;">
                            <td >{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{lead.id}}</td>
                            <td>{{lead.glamyo_patient_id}}</td>
                            <td>{{lead.lead_source_name}}</td>
                            <td>{{lead.lead_status_name}}</td>
                            <td>{{lead.city_name}}</td>
                            <td>{{lead.circle_name}}</td>
                            <td>{{lead.bd_name}}</td>
                            <td>{{lead.useremployee_id}}</td>
                            <td>{{lead.treatment_name}}</td>
                            <td>{{lead.description}}</td>
                            <td>{{lead.lead_date_time}}</td>
                            <!-- <td>
                                <span *ngFor="let fact of toJson(lead.first_action_json)">
                                    <span *ngIf="fact.first_action_date_time">
                                        <b>First Action on:</b> <br /> {{fact.first_action_date_time*1000|date:'d MMM, yyyy H:m:s'}} <br />
                                    </span>
                                    <span *ngIf="fact.first_action_message" >
                                        <b>Message: </b> <span [innerHTML]="fact.first_action_message | safe:'html'"></span> <br />
                                    </span>
                                </span>
                            </td> -->
                            <td>{{lead.followup_date}}</td>
                            <!-- <td>
                                <span *ngFor="let callD of toJson(lead.call_details)">
                                    <span *ngIf="lead.lead_source==2 && callD.call_recording_url"><a target="_blank" href="{{callD.call_recording_url}}">View Recording</a><br /></span>
                                </span>
                            </td>
                            <td>
                                <span *ngFor="let kcallD of toJson(lead.total_click_to_call)">
                                    <span *ngIf="kcallD.kcc_recording"><a target="_blank" href="http://{{kcallD.kcc_recording}}">View Recording </a>
                                    <span *ngIf="kcallD.kcc_duration">(Duration:- {{kcallD.kcc_duration}})</span>
                                    <br /></span>
                                </span>
                            </td> -->
                            <td>
                                <span *ngFor="let ncallD of toJson(lead.total_nimbus_click_to_call)">
                                    <span *ngIf="ncallD.ncc_recording"><a target="_blank" href="{{ncallD.ncc_recording}}">View Recording </a>
                                    <span *ngIf="ncallD.ncc_duration">(Duration:- {{ncallD.ncc_duration}})</span>
                                    <br /></span>
                                </span>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="18" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !leads.length">
                            <td colspan="18" ><i class="far fa-frown"></i> Leads not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>



            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>
